import { Outlet } from "@tanstack/react-router";

export default function DonateLayout() {
  // Each donate page renders its own <PageShell>, so the layout only
  // needs to provide the routing outlet (avoids a duplicate header/footer).
  return <Outlet />;
}
